<nav role="navigation" aria-label="Main navigation">
  <div class="kemper-logo-parent">
    <button type="button" (click)="onHeader()" id="logo-button" aria-label="Go to home" style="cursor: pointer; background: none; border: none; padding: 0;">
      <img src="assets/images/Vector.svg" class="kemper-logo-icon" alt="Kemper logo">
    </button>
    <div class="button-parent">
      <div class="button">
        <a class="kemper-logo-button" [href]="contactLink" target="_blank" rel="noopener noreferrer" id="contact-us-link" [attr.aria-label]="'contactUs' | translate">{{ "contactUs" |
          translate}}</a>
      </div>
      <img src="assets/images/Divider.svg" class="divider-icon" alt="">
      <div class="button">
        <button type="button" class="kemper-logo-button" (click)="toggleLanguage()" id="language-toggle-button" [attr.aria-label]="'language' | translate">{{ "language" | translate}}</button>
      </div>
    </div>
  </div>
</nav>